<template>
  <transition>
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="page-title-box">
            <div class="page-title-right float-left">
              <ol class="breadcrumb m-0">
                <li class="breadcrumb-item active">Service Stock Transfer</li>
                <li class="breadcrumb-item"><a href="javascript: void(0);">Transfer List</a></li>
              </ol>
            </div>
            <div class="page-title-right float-right">
              <button type="button" class="btn btn-primary float-right" @click="toggleModal()">
                Add New Transfer
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Transfer List -->
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <Datatable
                :columns="columns"
                :sortKey="tableData.sortKey"
                @sort="sortBy"
                v-if="!loading"
              >
                <template #header > 
                    <div class="tableFilters" style="margin-bottom: 10px;">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="control" style="float: left;">
                                    <span style="float: left; margin-right: 10px; padding: 7px 0px;">Show </span>
                                    <div class="select" style="float: left;">
                                        <select class="form-select" v-model="tableData.length" @change="fetchItems()"> 
                                            <option value="10" selected="selected">10</option>
                                            <option value="25">25</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                            <option value="500">500</option>
                                            <option :value="pagination.total">All</option>
                                        </select>
                                    </div>
                                    <span style="float: left; margin-left: 10px; padding: 7px 0px;"> Entries</span>
                                </div>
                            </div>
                            
                            <div class="col-md-2">
                                    
                            </div>
                            <div class="col-md-4">
                                <input type="text" class="form-control" style="float: right;" v-model="tableData.search" placeholder="Search..." @input="fetchItems()">
                            </div>
                        </div>
                    </div>   
                </template> 

                <template #body>
                  <tbody v-if="items.length > 0">
                    <tr v-for="(item, i) in items" :key="i">
                      <td class="text-center">{{ i + 1 }}</td>
                      <td class="text-center">{{ item.transfer_no }}</td>
                      <td class="text-center">{{ item.outlets.name ?? '' }}</td>
                      <td class="text-center" style="text-transform: capitalize;">{{ item.to_location_type  }}</td>
                      <td class="text-center">{{ item.total_items }}</td>
                      <td class="text-center">{{ item.total_value }}</td>
                      <!-- <td class="text-center">
                        <span v-if="item.status == 1" class="badge bg-warning">Pending</span>
                        <span v-else-if="item.status == 2" class="badge bg-info">Approved</span>
                        <span v-else class="badge bg-success">Completed</span>
                      </td> -->
                      <td class="text-center">
                        <div class="dropdown float-end">
                          <a href="#" class="dropdown-toggle arrow-none card-drop" data-bs-toggle="dropdown" aria-expanded="false">
                            <i class="mdi mdi-dots-vertical"></i>
                          </a>
                          <div class="dropdown-menu dropdown-menu-end">
                            <a href="javascript:void(0);" class="dropdown-item text-primary" @click="viewDetails(item)">
                              <i class="mdi mdi-circle-eye-outline"></i> View
                            </a>
                            <!-- <a href="javascript:void(0);" class="dropdown-item text-warning" @click="edit(item)">
                              <i class="mdi mdi-circle-edit-outline"></i> Edit
                            </a>
                            <a href="javascript:void(0);" class="dropdown-item text-danger" @click.prevent="deleteItem(item)">
                              <i class="mdi mdi-delete-outline"></i> Remove
                            </a> -->
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="8" class="text-center">No Data Available Here!</td>
                    </tr>
                  </tbody>
                </template>

                <template #footer>
                  <Pagination 
                    :pagination="pagination"   
                    :language="lang"
                    @onChangePage="setPage">
                  </Pagination>
                </template>
              </Datatable>

              <div class="text-center" v-if="loading">
                <img src="../../../assets/image/loading.gif" alt="Loading..." style="width: 130px;" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal -->
      <Modal @close="toggleModal()" :modalActive="modalActive">
        <div class="modal-content scrollbar-width-thin">
          <div class="modal-header">
            <h3>{{ editMode ? 'Edit Transfer' : 'Add New Transfer' }}</h3>
            <button @click="toggleModal()" type="button" class="btn btn-default">X</button>
          </div>

          <form @submit.prevent="submitForm()">
            <div class="modal-body">
              <div class="row">
                <div class="col-md-6 mb-2">
                  <label for="from_location">From Location *</label><br>
                  <Multiselect 
                    class="form-control border" 
                    mode="single"
                    v-model="form.from_location_id"
                    placeholder="Select Source"  
                    :searchable="true" 
                    :filter-results="true"
                    :options="location_options"
                    :classes="multiclasses"
                    :close-on-select="true" 
                    :min-chars="1"
                    :resolve-on-load="false"
                    @change="onChangeLocation($event)"
                    v-if="renderOptionComponent"
                    />
                </div>
                <div class="col-md-6 mb-2">
                  <!-- <label for="to_location">To Location *</label>
                  <treeselect v-model="form.to_location_id" :options="locations" placeholder="Select Destination"/> -->
                </div>
              </div>

              <div class="row mb-2">
                <div class="col-md-12">
                  <h5>Products</h5>
                  <table class="table table-bordered">
                    <thead>
                        <tr>
                            <th width="25%">Product</th>
                            <th>Qty</th>
                            <th>Cost/unit</th>
                            <th>Service Qty</th>
                            <th>Conversion Qty</th>
                            <th>Conversion Rate</th>
                            <th>Subtotal</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="form.items.length === 0">
                            <td colspan="8" class="text-center">No products added. Please add products.</td>
                        </tr>
                        <tr v-for="(item, index) in form.items" :key="index">
                            <td>
                                <Multiselect 
                                    class="form-control border" 
                                    mode="single"
                                    v-model="item.product_id"
                                    placeholder="Select Product"  
                                    :searchable="true" 
                                    :filter-results="true"
                                    :options="product_options"
                                    :classes="multiclasses"
                                    :close-on-select="true" 
                                    :min-chars="1"
                                    :resolve-on-load="false"
                                    @change="changeProduct($event, index)"
                                    v-if="renderOptionComponent"
                                />
                            </td>
                            <td>
                                <input type="number" v-model="item.qty" class="form-control" placeholder="Qty" @input="updateSubtotal(index)">
                            </td>
                            <td>
                                <input type="number" v-model="item.cost_per_unit" class="form-control" placeholder="Cost/unit" @input="updateSubtotal(index)">
                            </td>
                            <td>
                                <input type="number" v-model="item.service_qty" class="form-control" placeholder="Service Qty" @input="updateConversionRateQty(index)">
                            </td>
                            <td>
                                <input type="number" v-model="item.per_service_qty" class="form-control" placeholder="Conversion Qty" disabled>
                            </td>
                            <td>
                                <input type="number" v-model="item.per_service_cost" class="form-control" placeholder="Conversion Rate" disabled>
                            </td>
                            <td>
                                <input type="text" :value="item.subtotal" class="form-control" disabled>
                            </td>
                            <td>
                                <button type="button" class="btn btn-danger" @click="removeItem(index)">X</button>
                            </td>
                        </tr>
                    </tbody>
                  </table>
                  <button type="button" class="btn btn-primary" @click="addItem()">Add Product</button>
                </div>
              </div>

              <div class="row mt-2">
                <div class="col-md-12 text-end">
                  <h5>Total Cost: {{ totalCost() }}</h5>
                </div>
              </div>

              <div class="row mt-2">
                <div class="col-md-12">
                  <label for="note">Notes</label>
                  <textarea class="form-control" v-model="form.note" placeholder="Note" rows="3"></textarea>
                </div>
              </div>

              <!-- <div class="row mt-2">
                <div class="col-md-6">
                  <label for="status">Status</label>
                  <select class="form-select" v-model="form.status">
                    <option value="1">Pending</option>
                    <option value="2">Approved</option>
                    <option value="3">Completed</option>
                  </select>
                </div>
              </div> -->
            </div>

            <div class="modal-footer">
              <button type="button" class="btn btn-danger" @click="toggleModal()">Close</button>
              <button type="submit" class="btn btn-primary" :disabled="disabled">
                <span v-show="isSubmit"><i class="fas fa-spinner fa-spin"></i></span>
                {{ editMode ? 'Update' : 'Submit' }}
              </button>
            </div>
          </form>
        </div>
      </Modal>

      <!-- View and print Modal-->
        <Modal @close="toggleVoucherPrintModal()" :modalActive="voucherModalPrintActive">
        <div class="modal-content scrollbar-width-thin orderPreview">
            <div class="modal-header" style="text-align:right; display: block;">
            <button @click="toggleVoucherPrintModal()" type="button" class="btn btn-default">X</button>
            </div>
            <div class="modal-body">
            <div class="row">
            <div class="col-md-12">
                <div class="card">
                <div class="container" id="printArea">
                <div class="text-center col-xs-12">
                    <div class="row">
                    <p class="text-uppercase text-center mt-2"><strong>{{ retailShopName }}</strong></p>
                    <p class="text-uppercase text-center"><strong>{{ retailSmallText }}</strong></p>
                    <p class="text-uppercase text-center">{{ retailShopAddress }}</p>
                    <br>
                    </div>
                </div>
                <div class="d-flex justify-content-between">
                    <div class="col-xs-6">
                    <div class="row">
                    <div class="text-left">Transfer Date: {{ formatDateTime(transferData.created_at) }}</div>
                    </div>
                    <div class="row">
                    <div class="text-left">Transfer No: {{ transferData.transfer_no }}</div>
                    </div>
                    <div class="row">
                    <div class="text-left">From Location: {{ transferData?.outlets?.name }}</div>
                    </div>
                    <div class="row">
                    <div class="text-left">To Location: {{ transferData.to_location_type }}</div>
                    </div>
                    <div class="row">
                    <div class="text-left">Note: {{ transferData.note }}</div>
                    </div>
                    </div>
                    <div class="col-xs-6">
                    <div class="row">
                    <div class="text-left">Total Items: {{ transferData.total_items }}</div>
                    </div>
                    <div class="row">
                    <div class="text-left">Total Value: {{ transferData.total_value }}</div>
                    </div>
                    <!-- <div class="row">
                        <div class="text-left">Status:
                            <span v-if="transferData.status == 1" class="badge bg-warning">Pending</span>
                            <span v-else-if="transferData.status == 2" class="badge bg-info">Approved</span>
                            <span v-else class="badge bg-success">Completed</span>
                        </div>
                    </div> -->
                    </div>
                </div>
                <hr>
                <h5>Product Details</h5>
                <div class="table-responsive">
                    <table class="table table-bordered table-centered table-nowrap">
                    <thead>
                    <tr>
                        <th class="text-center" style="width: 5%">SL</th>
                        <th class="text-center">Product</th>
                        <th class="text-center">Qty</th>
                        <th class="text-center">Cost/unit</th>
                        <th class="text-center">Service Qty</th>
                        <th class="text-center">Conversion Qty</th>
                        <th class="text-center">Conversion Rate</th>
                        <th class="text-center">Subtotal</th>
                    </tr>
                    </thead>
                    <tbody v-if="transferItems.length > 0">
                    <tr v-for="(item, i) in transferItems" :key="i">
                        <td class="text-center">{{ i + 1 }}</td>
                        <td class="text-center">{{ item.products.product_name }}</td>
                        <td class="text-center">{{ item.qty }}</td>
                        <td class="text-center">{{ item.unit_cost }}</td>
                        <td class="text-center">{{ item.service_qty }}</td>
                        <td class="text-center">{{ item.per_service_qty }}</td>
                        <td class="text-center">{{ item.per_service_cost }}</td>
                        <td class="text-center">{{ item.item_total }}</td>
                    </tr>
                    <tr>
                        <td colspan="7" class="text-end"><strong>Total</strong></td>
                        <td class="text-center"><strong>{{ totalTransferCost }}</strong></td>
                    </tr>
                    </tbody>
                    <tbody v-else>
                    <tr>
                        <td colspan="8" class="text-center">No products found for this transfer.</td>
                    </tr>
                    </tbody>
                    </table>
                </div>
                </div>
                </div>
            </div>
            </div>
            </div>
        </div>
        </Modal>
    </div>
  </transition>
</template>

<script>
import Modal from "./../../helper/Modal";
import Datatable from '@/components/Datatable.vue';
import Pagination from '@/components/Pagination.vue';
import { ref } from "vue";
import Form from 'vform';
import axios from 'axios';

export default {
    name: "ServiceStockTransfer",
    components: { 
        Modal, 
        Datatable, 
        Pagination 
    },
    props:{
        language: {
            type: Object,
            default: () => {
            return {
                lengthMenu: null,
                info: null,
                zeroRecords: null, 
                search: null
            }
            },
        },
    },
    data() {
        return {
            loading: true,
            modalActive: false,
            voucherModalPrintActive: false,
            editMode: false,
            isSubmit: false,
            disabled: false,
            renderOptionComponent: true,
            transferData: {},
            transferItems: [],
            totalTransferCost: 0,
            items: [],
            locations: [],
            location_options: [],
            products: [],
            product_options: [],
            form: new Form({
                id: '',
                from_location_id: null,
                to_location_id: null,
                items: [
                    { 
                        product_id: null, 
                        qty: 1, 
                        cost_per_unit: 0, 
                        service_qty: 0, 
                        per_service_qty:0, 
                        per_service_cost:0,
                        subtotal: 0 
                    }
                ],
                note: '',
                status: 1
            }),
            columns: [
                { label: 'SL', name: '', width: '5%' },
                { label: 'Transfer No', name: 'transfer_no', width: '15%' },
                { label: 'From', name: 'from_location_name', width: '15%' },
                { label: 'To', name: 'to_location_name', width: '15%' },
                { label: 'Total Items', name: 'total_items', width: '10%' },
                { label: 'Total Cost', name: 'total_cost', width: '10%' },
                // { label: 'Status', name: 'status', width: '10%' },
                { label: 'Actions', name: '', width: '10%', isAction:true }
            ],
            tableData: { draw: 0, length: 10, search: '', column: 1, dir: 'asc', sortKey: 'transfer_no' },
            
            lang: {
                lengthMenu: this.$props.language.lengthMenu ? this.$props.language.lengthMenu : 'Show_MENU_entries',
                info: this.$props.language.info ? this.$props.language.info : 'Showing_FROM_to_TO_of_TOTAL_entries',
                zeroRecords: this.$props.language.zeroRecords ? this.$props.language.zeroRecords : 'No data available in table.', 
                search: this.$props.language.search ? this.$props.language.search : 'Search'
            },
            pagination: { currentPage: 1, total: 0, links: [] },
            multiclasses: { 
                clear: '',
                clearIcon: '', 
            },
        }
    },
    created() {
        this.fetchLocations();
        this.fetchProducts();
        this.fetchItems();
    },
    methods: {
        formatDateTime(date) {
            if (!date) return '';
            const d = new Date(date);
            return d.toLocaleString();
        },
        forceRerender() {
            // Remove my-component from the DOM
            this.renderOptionComponent = false;

            this.$nextTick(() => {
                // Add the component back in
                this.renderOptionComponent = true;

            });
        },
        toggleModal() {
            this.modalActive = !this.modalActive;
            if (!this.modalActive) {
                this.editMode = false;
                this.form.reset();
                this.form.items = [{
                    product_id: null, 
                    qty: 1, 
                    cost_per_unit: 0, 
                    service_qty: 0, 
                    per_service_qty:0,
                    per_service_cost:0,
                    subtotal: 0
                }];
            }
        },
        toggleVoucherPrintModal() {
            this.voucherModalPrintActive = !this.voucherModalPrintActive;
        },
        addItem() {
            this.form.items.push({ 
                product_id: null, 
                qty: 1, 
                cost_per_unit: 0, 
                service_qty: 0, 
                per_service_qty:0,
                per_service_cost:0,
                subtotal: 0
            });
        },
        removeItem(index) {
            if(this.form.items.length === 1) {
                this.$toast.error('At least one product is required.');
                return;
            }
            this.form.items.splice(index, 1);
        },
        updateSubtotal(index) {
            let item = this.form.items[index];
            item.subtotal = item.qty * item.cost_per_unit;
            this.updateConversionRateQty(index);
        },
        updateConversionRateQty(index) {
            let item = this.form.items[index];
            let conversion_qty = item.qty / item.service_qty;
            item.per_service_qty = conversion_qty || 0;
            let conversion_rate = item.cost_per_unit * conversion_qty;
            item.per_service_cost = conversion_rate || 0;
        },

        totalCost() {
            return this.form.items.reduce((acc, i) => acc + i.subtotal, 0);
        },

        fetchLocations() {
            axios.get(this.apiUrl + '/outlets', this.headerjson)
            .then(res => {
                this.locations = res.data.data;
                this.location_options = this.locations.map(loc => ({ value: loc.id, label: loc.name }));
            });
        },

        onChangeLocation(value) {
            this.form.items = [{
                product_id: null, 
                qty: 1, 
                cost_per_unit: 0, 
                service_qty: 0, 
                per_service_qty:0,
                per_service_cost:0,
                subtotal: 0
            }];
            let products = this.products.filter(p => p.outlet_id === value);
            this.product_options = products.map(p => ({ value: p.id, label: p.product_name }));
            this.forceRerender();
        },

        fetchProducts() {
            axios.get(this.apiUrl + '/service-products', this.headerjson).then(res => {
                this.products = res.data.data;
            });
        },

        changeProduct(value, index) {
            if (this.form.items.some((itm, idx) => itm.product_id === value && idx !== index)) {
                this.$toast.error('Product already exists in the list!');
                this.form.items.splice(index, 1);
                return false;
            }
            let selectedProduct = this.products.find(p => p.id === value);
            if (selectedProduct) {
                this.form.items[index].cost_per_unit = selectedProduct.cost_price || 0;
                this.form.items[index].service_qty = selectedProduct.service_qty || 0;

                let conversion_qty = this.form.items[index].qty / selectedProduct.service_qty;
                this.form.items[index].per_service_qty = conversion_qty || 0;
                let conversion_rate = selectedProduct.cost_price * conversion_qty;
                this.form.items[index].per_service_cost = conversion_rate || 0;
                this.updateSubtotal(index);
            }
        },

        fetchItems(url = this.apiUrl + '/hm/service_stock_transfers') {
            this.loading = true;
            axios.get(url, { params: this.tableData, headers:this.headerparams })
            .then(res => {
                const data = res.data.data.data;
                this.items = data.data;
                this.pagination = {
                currentPage: data.current_page,
                total: data.total,
                links: data.links
                };
            }).finally(() => this.loading = false);
        },

        configPagination(data){
            this.pagination.lastPage = data.last_page;
            this.pagination.currentPage = data.current_page;
            this.pagination.total   = data.total ? data.total : 0;
            this.pagination.lastPageUrl = data.last_page_url;
            this.pagination.nextPageUrl = data.next_page_url;
            this.pagination.prevPageUrl = data.prev_page_url;
            this.pagination.from = data.from ? data.from : 0;
            this.pagination.to = data.to ? data.to : 0;  
            this.pagination.links = data.links;
        },
        sortBy(key,sortable) {
            this.tableData.sortKey = key;
            //this.sortOrders[key] = this.sortOrders[key] * -1;
            this.tableData.column = this.getIndex(this.columns, 'name', key);
            this.tableData.dir = sortable; ///this.sortOrders[key] === 1 ? 'asc' : 'desc'; 
            this.fetchItems();
        },
        setPage(data){  
            this.fetchItems(data.url); 
        },
        getIndex(array, key, value) {
            return array.findIndex(i => i[key] == value)
        },

        viewDetails(item) {
            this.transferData = item;
            this.transferItems = item.transfer_items;
            this.totalTransferCost = this.transferItems.reduce((acc, i) => acc + Number(i.item_total || 0), 0);
            this.toggleVoucherPrintModal();
        },

        edit(item) {
            this.editMode = true;
            this.form.fill(item);
            this.toggleModal();
        },
        submitForm() {
            this.isSubmit = true;
            this.disabled = true;
            const formData = {...this.form};
            let request;
            if(this.editMode) {
                request = axios.put(this.apiUrl + '/hm/service_stock_transfers/' + this.form.id, formData, this.headerjson);
            } else {
                request = axios.post(this.apiUrl + '/hm/service_stock_transfers', formData, this.headerjson);
            }
            request.then(res => {
                this.$toast.success(res.data.message);
                this.toggleModal();
                this.fetchItems();
            }).catch(err => {
                this.$toast.error(err.response?.data?.message || 'Error');
            }).finally(() => {
                this.isSubmit = false;
                this.disabled = false;
            });
        },
        deleteItem(item) {
            this.$swal({
                title: 'Are you sure?',
                text: "You want to delete this transfer!",
                showCancelButton: true,
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.value) {
                axios.delete(this.apiUrl + '/service_stock_transfers/' + item.id)
                    .then(res => {
                    this.$toast.success(res.data.message);
                    this.fetchItems();
                    });
                }
            });
        },
    }
}
</script>

<style scoped>
.modal-content.scrollbar-width-thin { width: 1000px; }
.invalid-feedback { display:block; color:#dc3545; font-size: 80%; }
</style>
